var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.5C9.83579 6.5 9.5 6.83579 9.5 7.25C9.5 7.66421 9.83579 8 10.25 8H17.25C17.6642 8 18 7.66421 18 7.25C18 6.83579 17.6642 6.5 17.25 6.5H10.25Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.25C9.5 9.83579 9.83579 9.5 10.25 9.5H17.25C17.6642 9.5 18 9.83579 18 10.25C18 10.6642 17.6642 11 17.25 11H10.25C9.83579 11 9.5 10.6642 9.5 10.25Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.5C15.3358 12.5 15 12.8358 15 13.25C15 13.6642 15.3358 14 15.75 14H17.25C17.6642 14 18 13.6642 18 13.25C18 12.8358 17.6642 12.5 17.25 12.5H15.75Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.25C15 15.8358 15.3358 15.5 15.75 15.5H17.25C17.6642 15.5 18 15.8358 18 16.25C18 16.6642 17.6642 17 17.25 17H15.75C15.3358 17 15 16.6642 15 16.25Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13C9.94772 13 9.5 13.4477 9.5 14V16C9.5 16.5523 9.94772 17 10.5 17H12.5C13.0523 17 13.5 16.5523 13.5 16V14C13.5 13.4477 13.0523 13 12.5 13H10.5Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60139 19.5C6.58817 19.8515 6.53093 20.1382 6.42963 20.3599C6.31311 20.6204 6.10663 20.8337 5.81006 21H18.3846C19.2478 21 19.8992 20.77 20.3387 20.3099C20.7783 19.8555 20.998 19.1848 20.998 18.2979V5.70209C20.998 4.80969 20.7783 4.13626 20.3387 3.68176C19.8992 3.22726 19.2478 3 18.3846 3H9.2099C8.35199 3 7.70325 3.22726 7.26373 3.68176C6.82416 4.13626 6.60437 4.80969 6.60437 5.70209V19.3372C6.60437 19.3929 6.60338 19.4472 6.60139 19.5ZM19.2605 19.2671L19.2542 19.2737L19.2542 19.2674L19.2516 19.2702L19.2542 19.2737C19.1874 19.3437 18.9892 19.5 18.3846 19.5H8.10218C8.10367 19.4454 8.10437 19.3911 8.10437 19.3372V5.70209C8.10437 5.0377 8.26736 4.80169 8.34195 4.72457L8.34408 4.72741L8.34577 4.72457H8.34195C8.40939 4.65483 8.60879 4.5 9.2099 4.5H18.3846C18.9939 4.5 19.1945 4.65636 19.2605 4.72457L19.262 4.72614C19.2694 4.73263 19.2761 4.73991 19.2815 4.74803C19.3618 4.8453 19.498 5.0947 19.498 5.70209V18.2979C19.498 18.9537 19.3365 19.1885 19.2605 19.2671Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.1705V11.8208C3 11.4328 3.07414 11.103 3.22242 10.8314C3.37599 10.5543 3.58253 10.3464 3.84201 10.2078C4.1015 10.0693 4.39806 10 4.73168 10H5.05737V19.1705C5.05737 19.3977 5.00971 19.5889 4.91438 19.7441C4.81906 19.9049 4.69196 20.0241 4.5331 20.1016C4.37952 20.1847 4.21271 20.2291 4.03265 20.2347C3.84731 20.2347 3.6752 20.1931 3.51633 20.11C3.36276 20.0268 3.2383 19.9049 3.14298 19.7441C3.04766 19.5889 3 19.3977 3 19.1705Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryIcon);
export default __webpack_public_path__ + "static/media/OrderHistoryIcon.2620be4a1dff914df93c45687f5301cb.svg";
export { ForwardRef as ReactComponent };